"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = require("coveo-search-ui");
var HTMLUtils_1 = require("./HTMLUtils");
var SearchInterfacesProvider = (function () {
    function SearchInterfacesProvider() {
    }
    SearchInterfacesProvider.prototype.getSearchInterfacesInPage = function (componentsIds) {
        var searchInterfacesSelector = this.getSearchInterfacesSelectorFromComponentIds(componentsIds);
        var searchInterfaces = document.querySelectorAll(searchInterfacesSelector);
        return HTMLUtils_1.nodeListToArray(searchInterfaces);
    };
    SearchInterfacesProvider.prototype.getSearchInterfacesSelectorFromComponentIds = function (componentIds) {
        return componentIds.map(function (componentId) { return coveo_search_ui_1.Component.computeSelectorForType(componentId); })
            .join(", ");
    };
    return SearchInterfacesProvider;
}());
exports.SearchInterfacesProvider = SearchInterfacesProvider;



//////////////////
// WEBPACK FOOTER
// ./src/utils/SearchInterfaceProvider.ts
// module id = 46
// module chunks = 13 14